import { render, staticRenderFns } from "./NewFbPost.vue?vue&type=template&id=0f37a9c8&"
import script from "./NewFbPost.vue?vue&type=script&lang=js&"
export * from "./NewFbPost.vue?vue&type=script&lang=js&"
import style0 from "./NewFbPost.vue?vue&type=style&index=0&id=0f37a9c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports